import { render, staticRenderFns } from "./manage-patient.html?vue&type=template&id=39b593f9&scoped=true&external"
import script from "./manage-patient.js?vue&type=script&lang=js&external"
export * from "./manage-patient.js?vue&type=script&lang=js&external"
import style0 from "./manage-patient.scss?vue&type=style&index=0&id=39b593f9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b593f9",
  null
  
)

export default component.exports